import { toRaw } from 'vue';
// name: homeTile
const state = {
  tileMap: new Map(),
};
const getters = {
  tileMap: (state)=> state.tileMap,
};
const mutations = {
  mapSet(state, data){
    const { id, tile } = data;
    // tile && map.addLayer(tile);
    state.tileMap.set(id, tile);
    state.tileMap = new Map(state.tileMap);
  },
  mapDel(state, data){
    const { id } = data;
    // tile && map.removeLayer(tile);
    state.tileMap.delete(id);
    state.tileMap = new Map(state.tileMap);
  },
  mapChange(state, data){
    const { flag, map } = data;
    if(!map)return;
    state.tileMap.forEach((val, key) => {
      if(flag){
        map.addLayer && map.addLayer(toRaw(val));
      }else{
        map.removeLayer && map.removeLayer(toRaw(val));
      }
    });
  },
  mapClose(state){
    state.tileMap.clear && state.tileMap.clear();
    state.tileMap = new Map(state.tileMap);
  },
};
const actions = {
  
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
